import { useAppDispatch } from "@/store/hooks";
import { updateSlide } from "@/store/slideEditorSlice";
import type { SlideFields } from "@/types/Slide";
import type { GrammarSlideData } from "@ai-teach/types";
import type { MediaInput, SlideHandlers } from "../types";

/**
 * Handlers for grammar slide type
 * Grammar slides use the canvas element system
 */
export const useGrammarHandlers = (slide: SlideFields | null): SlideHandlers => {
  const dispatch = useAppDispatch();

  const grammarSlideData = slide?.slideData as GrammarSlideData | undefined;

  if (!slide || !grammarSlideData) {
    // Return no-op functions if no slide data
    return {
      addImage: () => {},
      addAudio: () => {},
      addText: () => {},
    };
  }

  const slideId = slide.id;

  /**
   * Add image to grammar slide
   * Updates the imageId property in slideData
   */
  const addImage = ({ src, id, filename }: MediaInput) => {
    dispatch(
      updateSlide({ slideId, slideData: { ...grammarSlideData, image: { src, id, filename } } })
    );
  };

  /**
   * Add audio to grammar slide
   * Updates the wordAudioId property in slideData
   */
  const addAudio = ({ src, id, filename }: MediaInput) => {
    dispatch(
      updateSlide({ slideId, slideData: { ...grammarSlideData, audio: { src, id, filename } } })
    );
  };

  /**
   * Update the grammar text
   */
  const addText = (text: string) => {
    dispatch(updateSlide({ slideId, slideData: { ...grammarSlideData, text: text } }));
  };

  return {
    addImage,
    addAudio,
    addText,
  };
};
